import React from 'react';
import PropTypes from 'prop-types';

function ChatSuggestion({ name, onCreate }) {
  return (
    <button
      type="button"
      className="new-chat-practitioner-item flex items-center pa3 pointer w-100 bn tl bg-inherit"
      onClick={onCreate}
      aria-label={`Start conversation with ${name}`}
    >
      <p className="f5 ma0">{name}</p>
    </button>
  );
}

ChatSuggestion.propTypes = {
  name: PropTypes.string.isRequired,
  onCreate: PropTypes.func.isRequired,
};

export default ChatSuggestion;
